"use client";

import Image from "next/image";
import ctaImage from "../../../public/blog-images/cta.png";
import { Button } from "../ui/button";

export function BlogCTACard() {
  return (
    <div className="font-inter antialiased bg-transparent tracking-tight">
      <div className="flex flex-row p-3xl portrait:flex-col rounded-2xl bg-[#222129] border items-center px-6xl py-6xl gap-xl portrait:py-xl portrait:px-4xl">
        <div className=" text-slate-100 bg-clip-text">
          <h2
            className="h3 bg-clip-text text-transparent bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 mb-3xl"
            data-aos="fade-down"
          >
            <span className="text-lavareachOG">Cold Outbound </span>
            <br />
            never felt this easy.
          </h2>
          <p
            className="text-2xl text-slate-300 mb-8"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            Get high intent leads through relevant triggers with{" "}
            <span className="text-lavareachOG font-bold">tailored</span> AI
            research.
          </p>
          <Button
            data-aos="fade-down"
            data-aos-delay="400"
            size={"default"}
            className="shrink-0 block text-white text-center rounded-lg h-[37px] px-[27px] mt-4 sm:mt-0"
            style={{
              background:
                "linear-gradient(311deg, #d54712 26.7%, #f47c39 87.95%)",
            }}
          >
            <a
              href="/schedule"
              className="text-white hover:underline no-underline underline-offset-2 font-semibold"
            >
              Book a Demo
            </a>
          </Button>
        </div>

        <div
          className="flex justify-center portrait:px-4xl"
          data-aos="fade-down"
        >
          <Image
            src={ctaImage}
            alt="Try LavaReach Today"
            width={400}
            height={200}
            placeholder="blur"
          />
        </div>
      </div>
    </div>
  );
}

export function SeoBlogCTACard() {
  return (
    <div className="font-inter antialiased bg-transparent tracking-tight">
      <div className="flex flex-row p-3xl portrait:flex-col rounded-2xl bg-[#222129] border items-center px-6xl py-6xl gap-xl portrait:py-xl portrait:px-4xl">
        <div className=" text-slate-100 bg-clip-text">
          <h2
            className="h3 bg-clip-text text-transparent bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 mb-3xl"
            data-aos="fade-down"
          >
            Get
            <span className="text-lavareachOG"> SEO Prospects </span>
            <br />
            to Chase You
          </h2>
          <p
            className="text-2xl text-slate-300 mb-8"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            Provide value throughout your outreach with{" "}
            <span className="text-lavareachOG font-bold">LavaReach's </span>
            automated site audits.
          </p>
          <Button
            data-aos="fade-down"
            data-aos-delay="400"
            size={"default"}
            className="shrink-0 block text-white text-center rounded-lg h-[37px] px-[27px] mt-4 sm:mt-0"
            style={{
              background:
                "linear-gradient(311deg, #d54712 26.7%, #f47c39 87.95%)",
            }}
          >
            <a
              href="/schedule"
              className="text-white hover:underline no-underline underline-offset-2 font-semibold"
            >
              Book a Demo
            </a>
          </Button>
        </div>

        <div
          className="flex justify-center portrait:px-4xl"
          data-aos="fade-down"
        >
          <Image
            src={ctaImage}
            alt="Try LavaReach Today"
            width={400}
            height={200}
            placeholder="blur"
          />
        </div>
      </div>
    </div>
  );
}
